import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { MAU, SEMANTIC, SPACE, RADIUS } from "assets/theme/avocadoBrand";

/**
 * Đầu thẻ cho một bước trong luồng thu mua ngoài hiện trường: huy hiệu
 * "Bước N" nền vàng hạt bơ + tên luồng, tiêu đề, mô tả một dòng, và từ
 * bước 2 trở đi là dải "đang thu mua cho ai".
 */
function DauBuoc({ buoc, tieuDe, moTa, ngoaiCanh }) {
  return (
    <MDBox mb={2.5}>
      <MDBox display="flex" alignItems="center" gap={1.25} mb={tieuDe || moTa ? 1 : 0}>
        <MDBox
          px={1}
          py={0.5}
          sx={{
            backgroundColor: MAU.pit,
            borderRadius: `${RADIUS.sm}px`,
            lineHeight: 1,
          }}
        >
          <MDTypography variant="overline" color="dark" lineHeight={1} fontWeight="bold">
            Bước {buoc}
          </MDTypography>
        </MDBox>
        <MDTypography variant="overline" color="text" lineHeight={1}>
          Thu mua
        </MDTypography>
      </MDBox>

      {tieuDe && <MDTypography variant="h4">{tieuDe}</MDTypography>}
      {moTa && (
        <MDTypography variant="button" fontWeight="regular" color="text" display="block" mt={0.5}>
          {moTa}
        </MDTypography>
      )}

      {ngoaiCanh && (
        <MDBox
          mt={2}
          px={1.75}
          py={1.25}
          display="flex"
          alignItems="center"
          gap={1.25}
          sx={{
            backgroundColor: SEMANTIC.background,
            borderLeft: `${SPACE[1]}px solid ${SEMANTIC.primary}`,
            borderRadius: `${RADIUS.md}px`,
          }}
        >
          <Icon sx={{ color: SEMANTIC.primary, fontSize: "1.25rem" }}>agriculture</Icon>
          <MDBox minWidth={0}>
            <MDTypography variant="caption" color="text" display="block" lineHeight={1.2}>
              Đang thu mua cho
            </MDTypography>
            <MDTypography variant="button" fontWeight="medium" display="block">
              {ngoaiCanh}
            </MDTypography>
          </MDBox>
        </MDBox>
      )}
    </MDBox>
  );
}

DauBuoc.propTypes = {
  buoc: PropTypes.number.isRequired,
  tieuDe: PropTypes.node,
  moTa: PropTypes.node,
  ngoaiCanh: PropTypes.node,
};

DauBuoc.defaultProps = {
  tieuDe: null,
  moTa: null,
  ngoaiCanh: null,
};

export default DauBuoc;
